import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  APPROVAL_TABLE_HEAD_BG,
  approvalFormTableStyles,
} from '@/components/Approval/@components/ApprovalFormTable/styles';

/** 저장 HTML 의 태그·클래스로 맞춤 */
export const MarketingCaseRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': {
    ...approvalFormTableStyles(theme),
    minWidth: 640,
  },
  '& table + table': { marginTop: 16 },
  '& tbody th': { fontWeight: 500 },
  '& th.mkt-case-caption, & th.bg-info': {
    fontWeight: 600,
    backgroundColor: 'var(--dk-accent-soft, #EEF4FC)',
  },
  '& tbody td.title': {
    fontWeight: 500,
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
  },
  '& .mkt-case-brand-item': { whiteSpace: 'nowrap' },
  '& .mkt-case-brand-item.is-on': { fontWeight: 600 },
  // 글꼴 ■/□ 는 글자와 구분이 안 돼 칸으로 그림 — 글자는 복사·번역용으로 남김
  '& .mkt-case-check': {
    display: 'inline-block',
    verticalAlign: '-1px',
    boxSizing: 'border-box',
    width: 11,
    height: 11,
    border: '1px solid var(--dk-text, #1A1A1A)',
    fontSize: 0,
  },
  '& .is-on .mkt-case-check': {
    backgroundColor: 'var(--dk-text, #1A1A1A)',
  },
  '& .text-center': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  '& .mkt-case-image': {
    width: '95%',
    height: 300,
    objectFit: 'contain',
  },
  '& tr.mkt-case-subtotal td, & tr.mkt-case-total td': {
    fontWeight: 600,
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
  },
}));

export const MarketingCaseDetailRoot = styled(MarketingCaseRoot)({
  '& table': {
    minWidth: 880,
  },
  '& th': { wordBreak: 'keep-all' },
});

export const MarketingCaseSheetBody = styled(Box)({
  padding: '16px 16px 24px',
});
